/* eslint-disable react/no-string-refs */
import { h, Component } from 'preact';
import { Icon } from '@cube/blocks';
import { Text, Localizer } from 'preact-i18n';
import IconHeader from '../icon-header';
import IconListItem from '../icon-list-item';
import LocationsList from '../locations-list';
import ariaIDProvider from '../a11y';
import linkRef from 'linkref';
import style from './style';
import cx from 'classnames';

export function SearchForLocation({ value, onInput, onKeyDown, onKeyUp, a11yId, hideHeader, refocus, ...props }) {
	return (
		<div {...props}>
			<IconHeader id={a11yId} hidden={hideHeader}>
				<Text id="search" />
			</IconHeader>
			<Localizer>
				<TextInput
					value={value}
					onKeyDown={onKeyDown}
					onKeyUp={onKeyUp}
					onInput={onInput}
					aria-describedby={a11yId}
					placeholder={<Text id="inputPlaceholder" />}
					refocus={refocus}
				/>
			</Localizer>
		</div>
	);
}
export default ariaIDProvider('search-for-loc')(SearchForLocation);

export function SearchResults({ locations = [], isFavorite, isFavoritesFull, onSetCurrent, onAddFavorite, ...props }) {
	return (
		<LocationsList {...props} class={cx(style.searchResults, props.class)} live={`Found ${locations.length} results`}  aria-label="Search Results" hideHeader>
			{locations.map((location) => (
				<IconListItem
					location={location}
					icon="star-cube"
					class={cx(isFavorite && isFavorite(location) ? style.isFavorite : style.focusStar, isFavoritesFull && style.disabled)}
					onClickLocation={onSetCurrent}
					onClickIcon={isFavorite && !isFavorite(location) && onAddFavorite}
				/>
			))}
		</LocationsList>
	);
}

export class TextInput extends Component {
	handleInput = (e) => {
		this.props.onInput && this.props.onInput(e.target.value);
	};

	handleClearInput = () => {
		this.props.onInput && this.props.onInput('');
		this.refs.input && this.refs.input.focus();
	};

	componentWillReceiveProps({ value, refocus }) {
		if (this.props.value && !value) {
			this.refs.input && (this.refs.input.value = '');
		}
		if (refocus && this.props.refocus !== refocus) {
			this.refs.input && setTimeout(this.refs.input.focus.bind(this.refs.input));
		}
	}

	render({ value, ...props }) {
		return (
			<div class={style.inputContainer}>
				<input {...props} onInput={this.handleInput} ref={linkRef(this, 'input')} />
				{value && (
					<button aria-label={'Clear search'} onClick={this.handleClearInput}>
						<Icon name="exit-wire-cube" />
					</button>
				)}
			</div>
		);
	}
}
